import React from 'react';
import classNames from 'classnames';
import ArticleHeader from '../ArticleHeader';
import * as Render from '../Base/Render';
import ImageBlock from '../ImageBlock';
import Section from '../Section';
import withSrcSets from '../Containers/withSrcSets';
import withLazyLoad from '../Containers/withLazyLoad';
import withSensitiveImage from '../Containers/withSensitiveImage';

const Intro = (props) => {
  const ImageBlockWithSrcSet = withLazyLoad(
    withSrcSets(withSensitiveImage(ImageBlock))
  );

  const introClasses = classNames({
    'medium-8': true,
    'medium-centered': true,
    'large-uncentered': true,
    'large-7': props.Media,
    'large-8': !props.Media,
    columns: true,
  });

  return (
    <Section Modifiers={{ 'c-section--first': true, 'c-section--intro': true }}>
      <div className="row">
        <div className={introClasses}>
          <ArticleHeader
            Heading={props.Heading}
            HeadingTranslation={props.HeadingTranslation}
            Preamble={props.Preamble}
          />
        </div>
        {(props.Media || props.CurrentPageProps.IsEditMode) && (
          <div className="medium-8 medium-centered large-uncentered large-offset-1 large-4 columns">
            <Render.Block
              blocks={props.Media}
              propertyName="Image"
              currentPageProps={props.CurrentPageProps}
            >
              <ImageBlockWithSrcSet
                isBackgroundImage={true}
                UseZoom={false}
                ShowCaption={false}
                Modifiers={{
                  'c-imageblock--medium-margin': true,
                  'c-imageblock--is-intro': true,
                }}
                Sizes={{
                  sizes: '(min-width: 1025px) 407px, 100vw',
                }}
              />
            </Render.Block>
          </div>
        )}
      </div>
    </Section>
  );
};

export default Intro;
